type PriceProps = {
  currency?: string;
  locale?: string;
  children: number;
}

export const Price = ( { locale = 'en-us', currency, children }: PriceProps ) => {

  try {
    return Intl.NumberFormat( locale, {
      style: 'currency',
      currency,
    } ).format( children )
  } catch {
    return children;
  }
}
